import models from 'components/framework/models';
import { type RecordReferenceStruct } from './shared-types';
import { type ApplicationModelConstructor } from 'components/framework/ApplicationModel';

// Ported from DomainUrlHelpers
export function urlWithProtocol(url) {
  if (/:/.test(url)) {
    return url;
  } else if (/@/.test(url)) {
    return `mailto:${url}`;
  } else {
    return `http://${url}`;
  }
}

export function pathForRecordRef(
  recordRef: RecordReferenceStruct
): string | null {
  const ModelClass = models[
    recordRef.typename
  ] as ApplicationModelConstructor<any>;
  if (!ModelClass) return null;

  return ModelClass.pathForId(recordRef.id);
}
